import React, { useEffect, useState } from 'react'
import DataTableComponent from '../../../commonComponents/DataTableComponent';
import CallAPI from '../../../../../adminpanel/components/commonComponents/AxiosHelper';
import { Redirect } from 'react-router-dom';
import { setRequestId } from '../../../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const columnDataOptions = {
    dbColumns: [
        { "virtualName": "Client Table Name", "rawField": "tableName" },
        { "virtualName": "Pipeline", "rawField": "frequency", "edit": "mulitpleInput", },
        { "virtualName": "Date Filter", "rawField": "dateFilter" },
        { "virtualName": "Start Date", "rawField": "startDate", "displayType": "date" },
        { "virtualName": "End Date", "rawField": "endDate", "displayType": "date" },
        { "virtualName": "New Table Name", "rawField": "newTableName", "edit": "input" },
        { "virtualName": "Tags", "rawField": "tagAdded", "edit": "input" },
    ],
    sftpColumns: [
        { "virtualName": "File Name", "rawField": "fileName" },
        { "virtualName": "File Path", "rawField": "path" },
        { "virtualName": "Separator", "rawField": "separator", "edit": "mulitpleInput", },
        { "virtualName": "New Table Name", "rawField": "newTableName", "edit": "input" },
        { "virtualName": "Sheet Name", "rawField": "sheetName", "edit": "input" },
    ]
}

const StepFour = ({ initialData, authData, setRequestId }) => {

    const [stepFourTableData, setstepFourTableData] = useState([]);
    const [progressTable, setprogressTable] = useState(true);
    const [redirectPath, setRedirectPath] = useState(null);
    const [loadingStatus, setLoadingStatus] = useState(false);
    let columnData = ['mysql', "postgres", "oracle", "sqlsrv", "mysql_tally"].indexOf(initialData.connection_type.toLowerCase()) > -1 ? columnDataOptions['dbColumns'] : columnDataOptions['sftpColumns'];
    let filterColumnName = ['mysql', "postgres", "oracle", "sqlsrv", "mysql_tally"].indexOf(initialData.connection_type.toLowerCase()) > -1 ? 'tableName' : 'fileName';

    useEffect(() => {
        setTimeout(() => {
            feather.replace()
        }, 2);
    }, [stepFourTableData])

    useEffect(() => {
        if (['mysql', "postgres", "oracle", "sqlsrv", "mysql_tally"].indexOf(initialData.connection_type.toLowerCase()) > -1) {
            let selectedTablesName = Object.keys(initialData.selectedTables);
            let dbtableData = [];
            selectedTablesName.map(el => {
                let { dateColumns, endDate, queryFilterData, startDate, validation, clientDBName, clientTableName, orginalDateColumn, data_split, min_split, limit, columnName } = initialData.selectedTables[el];
                let tempName = clientTableName.split('_').map((el) => el[0].toUpperCase() + el.slice(1)).join(' ');
                dbtableData.push({ "tableName": el, "dateFilter": dateColumns ? dateColumns : "Entire Data", "startDate": startDate ? startDate : "NA", "endDate": endDate ? endDate : "NA", "filter": { "whereCondition": queryFilterData, 'columnName': columnName }, "validation": validation, "newTableName": tempName, "tagAdded": "Add Tags", "frequency": null, "clientTableName": clientTableName, "clientDBName": clientDBName, entireData: initialData.selectedTables[el].entireData ? initialData.selectedTables[el].entireData : null, "data_split": data_split, "min_split": min_split, 'limit': limit });
            })
            setstepFourTableData(dbtableData);
        } else {
            let selectedFilesName = Object.keys(initialData.selectedFiles);
            let sftptableData = [];
            selectedFilesName.map(el => {
                let { atime, filename, gid, mode, mtime, path, permission, selectedStatus, size, type, uid } = initialData.selectedFiles[el];
                let tempName = filename.split('.')[0];
                sftptableData.push({ "fileName": filename, "path": path, "separator": "Comma (,)", "newTableName": tempName, "sheetName": filename.includes('.xlsx') ? "Set Sheet Name" : "NA" });
            })
            setstepFourTableData(sftptableData);
        }
        setprogressTable(false);
    }, [])

    const handleLoadButton = (event) => {
        let params = {
            siteId: authData.siteId,
            auth: "system"
        }
        let url = '/app/system/pullClientData_v1';
        let dataToSend = {
            "api_request": true,
            "pull_information": [],
            "user": authData.userId
        }
        let dateCase = {}
        if (['mysql', "postgres", "oracle", "sqlsrv", "mysql_tally"].indexOf(initialData.connection_type.toLowerCase()) > -1) {
            stepFourTableData.map(singleObj => {
                if (singleObj.entireData == "true") {
                    dateCase['entireData'] = true
                    singleObj.limit ? dateCase['limit'] = singleObj.limit : null
                } else {
                    dateCase['dateColumn'] = singleObj.dateFilter
                    dateCase['startDate'] = singleObj.startDate
                    dateCase['endDate'] = singleObj.endDate
                    singleObj.min_split ? dateCase['min_split'] = singleObj.min_split : null
                    singleObj.data_split ? dateCase['data_split'] = singleObj.data_split : null
                }
                if (singleObj.filter) {
                    dateCase['filter'] = {}
                }
                singleObj.filter && singleObj.filter.whereCondition !== '' ? dateCase['filter']['whereCondition'] = singleObj.filter.whereCondition : null
                singleObj.filter && singleObj.filter.columnName !== '' ? dateCase['filter']['columnName'] = singleObj.filter.columnName : null
                if (Object.values(dateCase['filter']).length == 0) {
                    delete dateCase['filter']
                }
                singleObj.frequency !== null ? dateCase['frequency'] = JSON.parse(singleObj.frequency) : null
                singleObj.tagAdded !== "Add Tags" ? dateCase['tags'] = singleObj.tagAdded.split(',') : null
                dataToSend['pull_information'].push({
                    "connectionId": initialData.connectionId,
                    "clientTableName": singleObj.clientTableName,
                    "clientDBName": singleObj.clientDBName,
                    "virtualTableName": singleObj.newTableName,
                    "action": "create",
                    ...dateCase
                });
            });
        } else {
            stepFourTableData.map(singleObj => {
                if (singleObj.fileName && singleObj.fileName.includes('.accdb')) {
                    dataToSend['pull_information'].push({
                        "connectionId": initialData.connectionId,
                        "tableName": singleObj.fileName,
                        "filePath": `${singleObj.path}${singleObj.fileName}`,
                        "virtualTableName": singleObj.newTableName,
                        "action": "create",
                        "field_terminate": singleObj.separator === 'Comma (,)'
                            ? ","
                            : singleObj.separator === 'Semicolon (;)' ? ";" : "|",
                        "sheetName": singleObj.sheetName && singleObj.sheetName != "Set Sheet Name" && singleObj.sheetName != "NA" ? singleObj.sheetName : null,
                    });
                } else {
                    dataToSend['pull_information'].push({
                        "connectionId": initialData.connectionId,
                        "filePath": `${singleObj.path}${singleObj.fileName}`,
                        "virtualTableName": singleObj.newTableName,
                        "action": "create",
                        "field_terminate": singleObj.separator === 'Comma (,)'
                            ? ","
                            : singleObj.separator === 'Semicolon (;)' ? ";" : "|",
                        "sheetName": singleObj.sheetName && singleObj.sheetName != "Set Sheet Name" && singleObj.sheetName != "NA" ? singleObj.sheetName : null,
                    });
                }
            });
        }
        setLoadingStatus(true);
        //handle the status part inside the information array. edge cases handle later.
        CallAPI('post', url, dataToSend, params, 0, function (response) {
            if (response.status === true) {
                let requestId = response.information[0].id;
                setRequestId(requestId);
                alert(response.information[0].information);
                // pullStatus = tempInfoArr.every(el => el.status === true);
                // if (pullStatus === false) {
                //     event.preventDefault();
                //     alert("Target Table already exist or there was some issue.");
                // } else {
                //     alert("Target Table successfully created.");
                // }
                setLoadingStatus(false);
                setRedirectPath("/adminpanel/v2/apirequest/admin");
            }
        }, authData);
    }

    const handleUpdate = (inputValue, rowNumber, data, columnName) => {
        let tempObject = [...stepFourTableData];
        let valueToCheck = ['mysql', "postgres", "oracle", "sqlsrv", "mysql_tally"].indexOf(initialData.connection_type.toLowerCase()) > -1 ? 'tableName' : 'fileName';

        if (columnName === "newTableName" || columnName === "tagAdded" || columnName === "sheetName") {
            tempObject.map(individualObj => {
                if (individualObj[valueToCheck] === data[valueToCheck]) {
                    individualObj[columnName] = inputValue;
                }
            });
            setstepFourTableData(tempObject);
        } else if (columnName === "Separator") {
            tempObject.map(individualObj => {
                if (individualObj[valueToCheck] === data[valueToCheck]) {
                    if (inputValue.separator === ',') {
                        individualObj["separator"] = 'Comma (,)';
                    } else if (inputValue.separator === ';') {
                        individualObj["separator"] = 'Semicolon (;)';
                    } else {
                        individualObj["separator"] = 'Pipe (|)';
                    }
                }
            });
            setstepFourTableData(tempObject);
        } else {
            tempObject.map(individualObj => {
                if (individualObj[valueToCheck] === data[valueToCheck]) {
                    individualObj["frequency"] = {
                        "type": inputValue.type,
                        "time": inputValue.time,
                    }
                    individualObj["frequency"] = JSON.stringify(individualObj["frequency"]);
                }
            });
            setstepFourTableData(tempObject);
        }
    }

    let topButton = [
        {
            "name": "Load",
            "className": 'btn btn-primary btn-sm mg-r-10 text-white',
            "type": "add",
            "event": handleLoadButton,
            "key": `executeData${Math.floor(Math.random() * 10)}`,
            "loadingStatus": loadingStatus
        }
    ];
    let filterStatus = true;

    if (redirectPath) {
        return <Redirect to={redirectPath} />
    }
    return (
        <DataTableComponent
            tableData={stepFourTableData}
            setTableData={handleUpdate}
            addFilter={filterStatus}
            topButton={topButton}
            progressPending={progressTable}
            columnData={columnData}
            filterColumnName={filterColumnName}
            connectionType={initialData.connection_type.toLowerCase()}
        />)
}

function mapStateToProps(state) {
    return { authData: state.dataSet.authData };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setRequestId
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(StepFour);
